import 'regenerator-runtime/runtime';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { connect, Provider } from 'react-redux';
import store, { history } from './store';
import RouterComp from './router';
import { MESSAGES, LOCALE, storageMessages } from './i18n/i18n.utils';

window.__myapp_container = document.querySelector('[data-ui-role="content"]');

const RouterConnected = connect(state => {
    return {
        loadedRoutes: state.taber.loadedRoutes,
        navigateTo: state.navigation.navigateTo,
    };
})(RouterComp);

class IntlWrapper extends Component {
    render() {
        const locale = /*this.props.locale ||*/ LOCALE;
        const messages = window.shffdaq
            ? { ...MESSAGES[locale], ...((storageMessages && storageMessages[LOCALE]) || {}) }
            : MESSAGES[locale];

        return (
            <IntlProvider locale={locale} key={locale} messages={messages}>
                <RouterConnected history={history} />
            </IntlProvider>
        );
    }
}

ReactDOM.render(
    <div id="app-root">
        <Provider store={store}>
            {/*<ConnectedIntlWrapper/>*/}
            <IntlWrapper />
        </Provider>
    </div>,
    document.querySelector('[data-ui-role="content"]') || document.createElement('div')
);
